import { useMutation } from '@tanstack/react-query';
import { Promotion } from 'api/types';
import { Axios } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';

export type CreatePromotionMutationVariables = Partial<Omit<Promotion, 'id' | 'texts'>> & { texts?: Partial<Promotion['texts'][number]>[] };

export function useCreatePromotionMutation() {
  const axios = useAxios();
  return useMutation({
    mutationKey: ['CreatePromotion'],
    mutationFn: (promotion: CreatePromotionMutationVariables) => createPromotion(axios, promotion),
  });
}

function createPromotion(axios: Axios, promotion: CreatePromotionMutationVariables) {
  return axios.post('/op/v1/promotion', promotion);
}
